// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 594 ? "demo" : chunkId) + "." + {"147":"c8f83124","488":"94805b16","563":"51c8ce41","594":"825271d9","696":"8eaa25d7","727":"e2d74364"}[chunkId] + ".css";
};